import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CrudService } from '../../../../core';
import { Arquivo } from '../arquivo';

@Injectable({
    providedIn: 'root'
})
export class ArquivoCrudHttpService {
    resource = 'arquivos';

    constructor(private crudService: CrudService) { }

    /** Carrega um arquivo através do seu ID */
    load(id: number): Observable<Arquivo> {
        return this.crudService.load<Arquivo>(this.resource, id);
    }

    /** Exclui um arquivo através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
